module.exports = "<p>\n  next-step works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/next-step/next-step.component.html
// module id = ../../../../../src/app/next-step/next-step.component.html
// module chunks = main